// Primitive 4 — Card et CardHead.
// Le titre est en capitales espacées : la signature visuelle Mertens,
// reprise directement du site.

export function Card({ className = '', children, ...props }) {
  return (
    <section className={`card ${className}`.trim()} {...props}>
      {children}
    </section>
  );
}

export function CardHead({ title, children }) {
  return (
    <header className="card__head">
      <h2 className="card__title">{title}</h2>
      {children ? <div className="row">{children}</div> : null}
    </header>
  );
}

export function CardBody({ className = '', children }) {
  return <div className={`card__body ${className}`.trim()}>{children}</div>;
}

export default Card;
